import type { RouteObject } from "react-router-dom";
import { lazy } from 'react';
import CentrePage from "../pages/centre/page";
import NeuroplasticityPage from "../pages/neuroplasticity/page";
import TechnologyPage from "../pages/technology/page";
import TreatmentPage from "../pages/treatment/page";
import EquipmentPage from "../pages/equipment/page";
import AmadeoPage from "../pages/equipment/amadeo/page";
import GraspPage from "../pages/equipment/grasp/page";
import ExoskeletonPage from "../pages/equipment/exoskeleton/page";
import DiegoPage from "../pages/equipment/diego/page";
import MyroPage from "../pages/equipment/myro/page";
import PabloPage from "../pages/equipment/pablo/page";
import TymoPage from "../pages/equipment/tymo/page";
import TyrostationPage from "../pages/equipment/tyrostation/page";
import DWallPage from "../pages/equipment/dwall/page";
import TeleRehabPage from "../pages/equipment/telerehab/page";
import ResourcesPage from "../pages/resources/page";
import PathProgramPage from "../pages/treatment/path/page";
import StartProgramPage from "../pages/treatment/start/page";
import VipProgramPage from "../pages/treatment/vip/page";

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/centre',
    element: <CentrePage />,
  },
  {
    path: '/neuroplasticity',
    element: <NeuroplasticityPage />,
  },
  {
    path: '/technology',
    element: <TechnologyPage />,
  },
  {
    path: '/treatment',
    element: <TreatmentPage />,
  },
  {
    path: '/treatment/path',
    element: <PathProgramPage />,
  },
  {
    path: '/treatment/start',
    element: <StartProgramPage />,
  },
  {
    path: '/treatment/vip',
    element: <VipProgramPage />,
  },
  {
    path: '/equipment',
    element: <EquipmentPage />,
  },
  {
    path: '/equipment/amadeo',
    element: <AmadeoPage />,
  },
  {
    path: '/equipment/grasp',
    element: <GraspPage />,
  },
  {
    path: '/equipment/exoskeleton',
    element: <ExoskeletonPage />,
  },
  {
    path: '/equipment/diego',
    element: <DiegoPage />,
  },
  {
    path: '/equipment/myro',
    element: <MyroPage />,
  },
  {
    path: '/equipment/pablo',
    element: <PabloPage />,
  },
  {
    path: '/equipment/tymo',
    element: <TymoPage />,
  },
  {
    path: '/equipment/tyrostation',
    element: <TyrostationPage />,
  },
  {
    path: '/equipment/dwall',
    element: <DWallPage />,
  },
  {
    path: '/equipment/telerehab',
    element: <TeleRehabPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
